"use strict";


export function initInScope ($scope) {

    // disable on mobile
    if(matchMedia('(min-width: 768px)').matches){
        let $inputs = $scope.find( '.js-form-submit-on-change input, .js-form-submit-on-change .form-control').not('.js-submit-form-on-change__exclude');
        $inputs.on('change', function (e) {
            $(this).closest('form').submit();
        });
    }

    let $inputsOutside = $scope.find('.js-form-submit-on-change__input-outside');

    $inputsOutside.on('change', function (e) {
        let $form = $('#' + $(this).attr('form'));
        $form.submit();
    });

    $scope.find('.js-submit-form-on-change__submit-section-btn').on('click', function (e) {
        $(this).closest('form').submit();
    });
}